<template>
  <div class="input-rut">
    <InputText 
      v-model="formattedRut" 
      @input="onInput" 
      placeholder="Ingrese RUT" 
      :class="{'p-invalid': mostrarErrores && error}" 
      v-bind:[tooltipDirective]="tooltip" 
    />
    <small v-if="mostrarErrores && error" class="p-error">{{ error }}</small>
  </div>
</template>

<script>
import { ref, watch } from 'vue';

export default {
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    mostrarErrores: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: String,
      default: ''
    },
    error: {
      type: String,
      default: ''
    }
  },
  setup(props, { emit }) {
    const formattedRut = ref(props.modelValue);

    const formatRut = (rut) => {
      // Eliminar caracteres no numéricos
      rut = rut.replace(/\D/g, '');
      // Formatear el RUT
      if (rut.length > 1) {
        const rutBody = rut.slice(0, -1);
        const rutDv = rut.slice(-1);
        return `${rutBody.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')}-${rutDv}`;
      }
      return rut;
    };

    const onInput = (event) => {
      const inputValue = event.target.value;
      formattedRut.value = formatRut(inputValue);
      emit('update:modelValue', formattedRut.value.replace(/\D/g, '')); // Emitir solo números
    };

    watch(() => props.modelValue, (newValue) => {
      formattedRut.value = formatRut(newValue);
    });

    return {
      formattedRut,
      onInput
    };
  }
}
</script>

<style scoped>
.input-rut {
  margin-bottom: 1rem;
}
</style>